export const Translations_CZ = {
	footer: {
		join: "Připojte se kdiskusi. Není vyžadována aplikace ani přihlášení.",
		climate: "Pozitivní diskuse o klimatu.",
		tree: "Tento strom byl zasazen.",
		start: "Začněte video diskuse zdarma.",
	},
};
